<template>
  <div>
    <div class="footer-box">
      <span>加工厂签章:</span>
      <span class="m-l-200">
        制表：&nbsp;&nbsp;
        <span class="footer-line">{{createByName}}</span>
      </span>
      <span class="m-l-5">
        生管审批1：
        <span class="footer-line">{{productManagerName}}</span>
      </span>
      <span class="m-l-5">
        成控审批：
        <span class="footer-line">{{costManagerName}}</span>
      </span>
      <span>&nbsp;</span>
      
    </div>
    <div class="footer-box">
      <span class="m-l-250">统计：&nbsp;&nbsp;
        <span class="footer-line">{{statisticalExaminerName}}</span>
      </span>
      <span class="m-l-5">
        生管审批2：
        <span class="footer-line">{{productDirectorName}}</span>
      </span>
      <span class="m-l-5">
        成控签批：
        <span class="footer-line">{{costManagerRegistExaminerName}}</span>
      </span>
      <span>&nbsp;</span>
      <span>&nbsp;</span>
    </div>
    <div class="footer-box">
      <span class="m-l-250">
        财务部：
        <span class="footer-line"></span>
      </span>
      <span class="m-l-5">
        生管审批3：
        <span class="footer-line"></span>
      </span>
      <span class="m-l-5">
        供应链负责人审批：
        <span class="footer-line" style="width: 168px;"></span>
      </span>
      <span style="display: inline-block; width: 20px;">&nbsp;</span>
      <span>第{{currentPage}}页, 共{{totalPage}}页</span>
    </div>
    <!-- <div class="footer-box pagination">
      <span>第{{currentPage}}页, 共{{totalPage}}页</span>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "print-footer",
  props:{
    productManagerName: {
      type: String,
      default: ''
    },
    costManagerName: {
      type: String,
      default: ''
    },
    createByName: {
      type: String,
      default: ''
    },
    productDirectorName: {
      type: String,
      default: ''
    },
    statisticalExaminerName: {
      type: String,
      default: ''
    },
    costManagerRegistExaminerName: {
      type: String,
      default: ''
    },
    totalPage:{
      default: 1
    },
    currentPage:{
      default: 1
    }
  }
};
</script>

<style scoped>
.footer-box {
  padding-top: 25px;
}
.m-l-250 {
  margin-left: 190px;
}
.m-l-200 {
  margin-left: 115px;
}
.footer-line {
  font-size: 13px;
  width: 190px;
  display: inline-block;
  border-bottom: 1px solid #000;
}
.empty {
  margin-left: 82px;
}
.m-l-5 {
  margin-left: 10px;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  padding-top: 0;
}
</style>